import React from "react";
import HeadingComponent from "../UserInterface/HeadingComponent";
import LayoutCenter from "../UserInterface/LayoutCenter";
import Description from "../UserInterface/Description";
import GoIllusList from "./GoIllusList";

export const HCGoSteps = () => {
  const stepsList = [
    {
      imageUrl: "/static/images/svg/dokumensvg.svg",
      descText: "Siapkan dokumen yang dibutuhkan"
    },
    {
      imageUrl: "/static/images/svg/download-GOsvg.svg",
      descText: "Download dan buka aplikasi Home Credit Go! di Playstore"
    },
    {
      imageUrl: "/static/images/svg/OTPsvg.svg",
      descText: "Masukkan data dirimu & kode OTP yang dikirim ke nomormu"
    },
    {
      imageUrl: "/static/images/svg/OTPsvg(1).svg",
      descText: "Kode Goer kamu akan muncul setelah pendaftaran sukses"
    }
  ];

  const allowedProductList = [
    {
      title: "Produk pembiayaan di mitra retail Home Credit",
      subtitle:
        "Insentif hingga Rp 200.000 per kontrak yang sudah ditandatangani"
    },
    {
      title: "Produk Proteksi CriticalLifeCover",
      subtitle:
        "Insentif hingga Rp 70.000 per proteksi atas premi yang sudah dibayarkan"
    },
  ];
  return (
    <div className="hcgo-steps-wrapper">
      <LayoutCenter margin="0px 16px 48px 16px" column>
        <HeadingComponent
          margin="48px 16px 24px 16px"
          headingText="Cara Mudah Jadi Sobat Goers"
          fontWeight="bold"
        ></HeadingComponent>
        <LayoutCenter margin="0px">
          <GoIllusList illusList={stepsList} />
        </LayoutCenter>
        <LayoutCenter width="100%">
          <h2 className="hcgo-subtitle">
            Kuy sebarin promo produk yang ada di halaman depan aplikasi Home
            Credit GO! ke media sosialmu.
          </h2>
        </LayoutCenter>
        <LayoutCenter column marginMobile="24px 16px">
          <Description
            font="Roboto"
            fontWeight="bold"
            fontSize="24px"
            width="300px"
            fontMobile="18px"
            text="Produk yang Bisa Direkomendasikan"
          ></Description>
          <ol>
            {allowedProductList.map((item, idx) => {
              return (
                <li key={idx}>
                  <div className="step-list">
                    <Description
                      font="Roboto"
                      fontSize="16px"
                      width="336px"
                      align="left"
                      text={item.title}
                      margin="24px 16px 0px 16px"
                      mobileWidth="259px"
                      fontMobile="14px"
                      marginMobile="16px 0px 0px 0px"
                      alignMobile="left"
                    ></Description>
                    <Description
                      font="Roboto"
                      fontSize="12px"
                      width="336px"
                      align="left"
                      text={item.subtitle}
                      margin="0px"
                      fontMobile="10px"
                      mobileWidth="259px"
                    ></Description>
                  </div>
                </li>
              );
            })}
          </ol>
        </LayoutCenter>
        <LayoutCenter column>
          <Description
            font="Roboto"
            fontSize="24px"
            fontWeight="bold"
            width="460px"
            text="Gak pake lama. Daftarnya hanya sekitar 3 menit dan data kamu dijamin aman!"
            fontMobile="16px"
            marginMobile="32px 16px 24px 16px"
            mobileWidth="288px"
          ></Description>
          <button
            onClick={() =>
              window.open("https://go.onelink.me/17z1/WebHcg", "_blank")
            }
            className="download-button"
          >
            Download Home Credit Go!
          </button>
        </LayoutCenter>
      </LayoutCenter>
      <style jsx>
        {`
          .hcgo-steps-wrapper {
            display: flex;
            justify-content: center;
          }
          .terms-items {
            width: 220px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0px 10px;
          }
          .terms-wrapper {
            width: 100%;
            display: flex;
            justify-content: space-around;
          }
          .download-button {
            border: none;
            background-color: var(--color-red);
            padding: 8px 53.22px;
            color: var(--color-white);
            font-size: 16px;
            border-radius: 5px;
          }
          .download-button:hover {
            cursor: pointer;
          }
          .step-list {
            margin: 0px 16px;
          }
          .hcgo-subtitle {
            text-align: center;
            font-size: 21px;
          }
          @media only screen and (max-width: 600px) {
            .terms-items {
              width: 140px;
            }
            .terms-wrapper {
              flex-direction: column;
              align-items: center;
            }
            .download-button {
              font-size: 14px;
              padding: 8px 22.82px;
              margin-bottom: 48px;
            }
            .hcgo-subtitle {
              font-size: 18px;
            }
          }
        `}
      </style>
    </div>
  );
};
